import React from 'react';
import { createRoot } from 'react-dom/client';

import TagManager from 'react-gtm-module';
import reportWebVitals from './reportWebVitals';

import './i18n';
import { Article } from './components/Article';


import 'bootstrap/scss/bootstrap.scss';
import 'antd/dist/reset.css';
import './App.sass';
import './Website.sass';

import atlanta from "./articles/atlanta.txt?raw"

const contents = {
	atlanta
}

if (import.meta.env.VITE_APP_GTM) {
	const tagManagerArgs = {
		gtmId: 'GTM-' + import.meta.env.VITE_APP_GTM
	};

	TagManager.initialize(tagManagerArgs);
}

const rootElement = document.getElementById('article-root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);

// Get data-article from rootElement
const articleType = rootElement.getAttribute("data-article");

console.log("articleType", articleType)


root.render(
	<React.StrictMode>
		<Article
			content={<div dangerouslySetInnerHTML={{ __html: contents[articleType] }} />}
			radarWidth={900}
			radarHeight={850}
		/>
	</React.StrictMode>
);

reportWebVitals();